var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2027 19.077L60.9228 0.7973C60.6701 0.544533 60.3702 0.34402 60.04 0.207216C59.7098 0.0704129 59.3559 0 58.9986 0C58.6412 0 58.2873 0.0704129 57.9571 0.207216C57.627 0.34402 57.327 0.544533 57.0744 0.7973C56.8217 1.05007 7.04408 50.8261 7.04408 50.8261L7.15423 50.9362L6.98142 50.8898L0.137562 76.4296L0.141605 76.4307C-0.0191305 76.9081 -0.0435648 77.4209 0.0710462 77.9115C0.185657 78.4021 0.434774 78.851 0.790417 79.2078C1.18452 79.601 1.69005 79.8634 2.2384 79.9594C2.78675 80.0554 3.35136 79.9803 3.8556 79.7444L3.85762 79.7535L29.1502 72.9764L29.134 72.9168L29.1724 72.9552L79.2027 22.9254C79.4555 22.6728 79.656 22.3728 79.7928 22.0426C79.9296 21.7125 80 21.3586 80 21.0012C80 20.6439 79.9296 20.29 79.7928 19.9598C79.656 19.6297 79.4555 19.3297 79.2027 19.077ZM8.46196 71.4767L12.5266 56.3086L23.6312 67.4131L8.46196 71.4767Z",
    fill: "#0094FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.386d00f65b113c31132e0891a0a62881.svg";
export { ForwardRef as ReactComponent };